
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/betcast",
      function () {
        return require("private-next-pages/betcast/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/betcast"])
      });
    }
  